import load from 'little-loader';

export const applyPolyfill = () => new Promise(function (resolve, reject) {
    if (!window.FileReader) {
        window.FileReader = function () {
            this.readAsDataURL = () => {
                // TODO use some polyfill for IE < 11
                throw new Error('Your browser does not support attachments.');
            }
        }
    }

    if (
        !window.Intl ||
        !window.Intl.DateTimeFormat.prototype.formatToParts ||
        !window.MutationObserver
    ) {
        if (DLL_PATHS) {
            load(DLL_PATHS['polyfill'], () => {
                // TODO split and load only missing API
                window.Intl = require('intl');
                require('intl/locale-data/jsonp/en-FI.js');
                require('intl/locale-data/jsonp/fi-FI.js');
                require('intl/locale-data/jsonp/sv-FI.js');
                window.MutationObserver = require('mutation-observer');
                resolve();
            });
        }
        else {
            require.ensure([], () => {
                // TODO split and load only missing API
                window.Intl = require('intl');
                require('intl/locale-data/jsonp/en-FI.js');
                require('intl/locale-data/jsonp/fi-FI.js');
                require('intl/locale-data/jsonp/sv-FI.js');
                window.MutationObserver = require('mutation-observer');
                resolve();
            })
        }
    }
    else {
        resolve();
    }
});